import type { ReactNode } from 'react'

export default function SectionHeader({
  title,
  subtitle,
  rightActions,
  className = '',
}: {
  title: string
  subtitle?: string
  rightActions?: ReactNode
  className?: string
}) {
  return (
    <div className={`mb-3 flex items-start justify-between gap-3 ${className}`.trim()}>
      <div className="min-w-0">
        <h2 className="text-lg font-extrabold">{title}</h2>
        {subtitle ? <p className="mt-0.5 text-sm text-white/65">{subtitle}</p> : null}
      </div>
      {rightActions ? <div className="shrink-0">{rightActions}</div> : null}
    </div>
  )
}
